import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";

import { AuthService } from "../services/auth.service";
import { getDonorRedirectRoute } from "../utils/donor-navigation-utils";
import { LocaleService } from "../services/locale.service";

export const navigationGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const localeService = inject(LocaleService);

  const currentUrl = state.url;
  localeService.syncFromUrl(currentUrl);

  if (authService.isAdmin()) {
    const shouldRedirect =
      currentUrl === "/" ||
      currentUrl === "/redirect" ||
      currentUrl.startsWith("/hospital/coordinator/dashboard") ||
      currentUrl.startsWith("/questionnaire") ||
      currentUrl.startsWith("/journey");

    if (shouldRedirect) {
      return router.parseUrl("/hospital/admin/dashboard");
    }

    return true;
  }

  if (authService.isStaff()) {
    const shouldRedirect =
      currentUrl === "/" ||
      currentUrl === "/redirect" ||
      currentUrl.startsWith("/questionnaire") ||
      currentUrl.startsWith("/journey") ||
      currentUrl.startsWith("/hospital/admin/dashboard");

    if (shouldRedirect) {
      return router.parseUrl("/hospital/coordinator/dashboard");
    }

    return true;
  }
  return getDonorRedirectRoute(state.url);
};
